import { object } from "yup";

/**
 * TPX application identity and permission catalog.
 *
 * A role belongs to TPX when `role.application.id === TPX_APPLICATION_ID`.
 * Only those roles' permissions should be used for in-app access decisions.
 */
export const TPX_APPLICATION_ID = 8;
export const TPX_APPLICATION_NAME = "TPX";

export const PRODUCT_SYSTEM_IDS = Object.freeze({
  INTELLISIGHT: 120,
  REC: 117,
  DIGIAUDIT: 115,
});

// DigiPay has no PS system id yet; matched by system name until one exists.
export const PRODUCT_SYSTEM_NAMES = Object.freeze({
  DIGIPAY: "digipay",
});

/**
 * Permission `name` values used by the TPX client.
 * Keep this list aligned with the server-side permission catalog.
 */
export const TPX_PERMISSION_NAMES = Object.freeze({
  PLAN: "Plan",
  SETTINGS: "Settings",
  COA_MANAGEMENT: "COA Management",
  PLANNING_REPORT: "Planning",
  LOCK: "Lock",
});

/**
 * Standardized permission `value` levels used across modules.
 */
export const TPX_PERMISSION_VALUES = Object.freeze({
  VIEW: "View",
  EDIT: "Edit",
  CREATE: "Create",
  DELETE: "Delete",
});

export const TPX_PERMISSION = Object.freeze({
  planView: "Plan:View",
  planEdit: "Plan:Edit",
  planCreate: "Plan:Create",
  planDelete: "Plan:Delete",
  versionCreate: "Plan:Create New Version",
  coaManagementView: "COA Management:View",
  coaManagementEdit: "COA Management:Edit",
  planningReportView: "Export:View",
  planningReportEdit: "Export:Edit",
  settingsView: "Settings:View",
  settingsEdit: "Settings:Edit",
  lockPlan: "Plan Locking:Lock Plans",
  lockLine: "Plan Locking:Lock Line Items",
  lockDriver: "Plan Locking:Lock Drivers on Line Items",
  critiqueTemplateView: "Critique Templates:View",
  critiqueTemplateCreate: "Critique Templates:Create",
  critiqueTemplateEdit: "Critique Templates:Edit",
  critiqueTemplateDelete: "Critique Templates:Archive",
  allCritiqueView: "Critique:View",
  allCritiqueComment: "Critique:Comment",
  allCritiqueSubmit: "Critique:Submit",
  // TPX-2730: deleting a critique uses the Critique Templates:Create permission (product decision; matches backend).
  allCritiqueDelete: "Critique Templates:Create"
});
